import { getRailsClient } from "../client/railsClient";

const LeaderboardRoute = "/api/internal_api/atlas/v1/current_user/leaderboard";
const DashboardSnapshotRoute = "/api/internal_api/atlas/v1/current_user/dashboard";

export type DashboardSnapshot = {
  // railsClient camelizes response keys, so `current_level` arrives as `currentLevel`
  currentLevel: {
    id?: number;
    levelName?: string;
    statsCurrent?: number;
    statsTotal?: number;
    statsProgress?: number;
    pathName?: string;
  };
  lessons: {
    total?: number;
    completed?: number;
    recentlyCompleted?: number;
  };
};

export type LeaderBoardSnapshot = {
  users: {
    userId: string;
    fullName: string;
    points: number;
    position: number;
    isSelf: boolean;
  }[];
};

export const fetchLeaderboardSnapshot = async (): Promise<LeaderBoardSnapshot> => {
  const railsClient = getRailsClient();
  const { data } = await railsClient.get<LeaderBoardSnapshot>(LeaderboardRoute);
  return data;
};

export const fetchDashboardSnapshot = async (): Promise<DashboardSnapshot> => {
  const railsClient = getRailsClient();
  const { data } = await railsClient.get<DashboardSnapshot>(DashboardSnapshotRoute);
  return data;
};
